import axios from "axios";
import { applyMiddleware, compose, createStore } from "redux";
import axiosMiddleware from "redux-axios-middleware";
import { thunk } from "redux-thunk";

import apiClient from "../api/apiClient";
import mockAdapter from "../mocks/mockAdapter";
import { isIE } from "../components/Notifier";
import { IsExpired } from "../utils/tokenHandler";
import { parseApiError } from "../utils/apiErrorToast";

import reducers from "./ducks/index";
import { setError, setForbidden } from "./ducks/duckError";
import { getSideBarItems } from "./ducks/duckSidebar";
import { AUTH, getAuth, GET_COOKIES_MSTR } from "./ducks/duckAuth";
import { getCollectionItems } from "./ducks/duckSidebarCollection";

const IGNORE_ACTIONS = [AUTH, GET_COOKIES_MSTR];
const FORBIDDEN = 403;

export default function configureStore(initialState = {}) {
  const isDevelopment = process.env.NODE_ENV && process.env.NODE_ENV === "development";
  const useMocks = process.env.REACT_APP_USE_MOCKS === "true";
  const composeEnhancers =
    isDevelopment && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  const middlewareConfig = {
    interceptors: {
      request: [
        function ({ getState, dispatch }, req) {
          const {
            auth: { token, loading },
          } = getState();
          const type = req?.reduxSourceAction?.type;

          const hasToken = Boolean(token);

          if (hasToken && IsExpired(token) && !loading) {
            dispatch(getAuth());
          }

          if (type && !IGNORE_ACTIONS.includes(type) && hasToken && !IsExpired(token)) {
            req.headers = req.headers || {};
            req.headers.Authorization = `Bearer ${token}`;
          }

          if (type && !IGNORE_ACTIONS.includes(type) && hasToken && IsExpired(token)) {
            throw new axios.Cancel("Cancelled by Middleware to refreshToken");
          }

          return req;
        },
      ],
    },
    onError({ dispatch, error }) {
      if (error?.code === "ERR_CANCELED") {
        return error;
      }

      const parsedError = parseApiError(error);

      const currentPath = (window?.location?.pathname || "").toLowerCase();
      const isAdministrationPath = currentPath.includes("/administration/");
      const isHrAdministrationPath = currentPath.includes("/administration/hr");

      if (error?.response?.status === FORBIDDEN) {
        // eslint-disable-next-line no-console
        console.log(error?.response?.request?.responseURL);

        if (isAdministrationPath && !isHrAdministrationPath) {
          dispatch(setError("Access denied for one of the requested administration resources."));

          return error;
        }

        dispatch(getAuth());
        dispatch(setForbidden(error?.response?.data));
      }

      if (error?.response?.status !== FORBIDDEN) {
        dispatch(setError(parsedError.message, parsedError.details));
      }

      return error;
    },
  };

  const client = apiClient;

  if (useMocks) {
    client.defaults.adapter = mockAdapter;
    client.defaults.baseURL = "";
  }

  const middleware = [thunk, axiosMiddleware(client, middlewareConfig)];
  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  if (isIE()) {
    // eslint-disable-next-line no-console
    console.warn("Compatibility Problems. Please open in Chrome or Microsoft Edge(Chromium)");
  }

  const token = store.getState().auth.token;

  if (IsExpired(token) || isIE()) {
    store
      .dispatch(getAuth())
      .then(() => {
        console.log("Dispatching sidebar and collection items load 2");
        store.dispatch(getSideBarItems());
        store.dispatch(getCollectionItems());
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Ha ocurrido un error al obtener la autenticaciÃƒÂ³n. Detalles:", error);
      });
  } else {
    store.dispatch(getSideBarItems());
    store.dispatch(getCollectionItems());
  }

  return store;
}
